<div class="modal-overlay" *ngIf="show" (click)="onClose()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <div class="modal-title">
        <fa-icon [icon]="faCog" class="title-icon"></fa-icon>
        <h2>{{ 'USERS.CONFIGURATIONS.TITLE' | translate }}</h2>
      </div>
      <button class="close-button" (click)="onClose()" [attr.aria-label]="'BUTTON.CLOSE' | translate">
        <fa-icon [icon]="faTimes"></fa-icon>
      </button>
    </div>

    <div class="modal-body">
      <div class="user-info">
        <p>{{ 'USERS.CONFIGURATIONS.MANAGING_FOR' | translate }}: <strong>{{ username }}</strong></p>
      </div>

      <div *ngIf="loading" class="loading-state">
        <fa-icon [icon]="faSpinner" animation="spin" size="2x"></fa-icon>
        <p>{{ 'MESSAGE.LOADING' | translate }}</p>
      </div>

      <div *ngIf="!loading && configurations.length === 0" class="empty-state">
        <p>{{ 'USERS.CONFIGURATIONS.NO_CONFIGURATIONS' | translate }}</p>
      </div>

      <div *ngIf="!loading && configurations.length > 0" class="configurations-list">
        <div *ngFor="let type of getConfigTypes()" class="config-type-group">
          <h3 class="config-type-title">{{ getTypeLabel(type) | translate }}</h3>

          <div class="config-items">
            <div *ngFor="let config of configsByType[type]" class="config-item">
              <label class="checkbox-label">
                <input type="checkbox" [checked]="config.has_access" [disabled]="saving"
                  (change)="onCheckboxChange(config, $event)" class="config-checkbox" />
                <span class="checkbox-custom"></span>
                <span class="config-name">{{ config.display_label || config.key }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="onClose()" [disabled]="saving">
        {{ 'BUTTON.CLOSE' | translate }}
      </button>
    </div>
  </div>
</div>